/* search.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKTcp%7Bborder-radius%3Avar(--ds-radius-medium%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065UPgdg%7Bpadding-block%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL4gVvo%7Bpadding-inline%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP292QF%7Bgrid-template-columns%3Aauto%201fr%20auto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXru7Cj1%7Bbackground-color%3Avar(--ds-background-input%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0wOv4QJxkL%7Bcursor%3Atext%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbYbGa%7Bdisplay%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VUofl%7Bheight%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlMbh7%7Bmax-width%3A680px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6qWX3%3Ahover%7Bbackground-color%3Avar(--ds-background-input-hovered%2C%23f8f8f8)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3gzVzLutHW%3Aactive%7Bbackground-color%3Avar(--ds-background-input-pressed%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A30rem)%7B._2rTNeWgBM8%7Bdisplay%3Agrid%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2j3gqAg8pm%7Bgrid-column%3A1%2F-1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3B2K2Q7dHp%7Bgrid-row%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2j3gqA7dHp%7Bgrid-column%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2j3gqA7LI7%7Bgrid-column%3A3%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlaS7z%7Bmax-width%3A780px%7D");
import React, { Fragment } from 'react';
import { cx } from '@atlaskit/css';
import SearchIcon from '@atlaskit/icon/core/search';
import type { NewIconProps } from '@atlaskit/icon/types';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { Show } from '@atlaskit/primitives/compiled/show';
import { Text } from '@atlaskit/primitives/compiled/text';
import { useIsFhsEnabled } from '../fhs-rollout/use-is-fhs-enabled';
import { IconButton } from './themed/icon-button';
const styles = {
  root: "_0bjKvDKTcp _4c065UPgdg _2Y7lL4gVvo _2iEGP292QF _0hPCNLDIqT _0KLXru7Cj1 _24h04i2Njc _0wOv4QJxkL _3iDTPbYbGa _0jFU0VUofl _1EqgXlMbh7 _39xV02N91d _1eOmH6qWX3 _3gzVzLutHW _2rTNeWgBM8",
  buttonText: "_2j3gqAg8pm _3B2K2Q7dHp",
  iconBefore: "_2j3gqA7dHp _3B2K2Q7dHp _3iDTPbQ4SZ",
  elemAfter: "_2j3gqA7LI7 _3B2K2Q7dHp _3iDTPbQ4SZ",
  fullHeightSidebar: "_1EqgXlaS7z"
};
type SearchProps = {
  /**
   * Provide an accessible label, often used by screen readers.
   */
  label: React.ReactNode;
  /**
   * The icon component to render before the search input.
   */
  iconBefore?: React.ComponentType<NewIconProps & {
    spacing: 'spacious';
  }>;
  /**
   * The component to render after the search input.
   */
  elemAfter?: React.ReactNode;
  /**
   * Handler called on click.
   */
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  /**
   * An optional name used to identify events for [React UFO (Unified Frontend Observability) press interactions](https://developer.atlassian.com/platform/ufo/react-ufo/react-ufo/getting-started/#quick-start--press-interactions). For more information, see [React UFO integration into Design System components](https://go.atlassian.com/react-ufo-dst-integration).
   */
  interactionName?: string;
  'aria-haspopup'?: React.AriaAttributes['aria-haspopup'];
};

/**
 * __Search__
 *
 * The search element for the top navigation.
 */
export const Search: (props: SearchProps) => JSX.Element = ({
  label,
  onClick,
  iconBefore: IconBefore = SearchIcon,
  elemAfter,
  interactionName,
  'aria-haspopup': ariaHaspopup
}: SearchProps) => {
  const isFhsEnabled = useIsFhsEnabled();
  return <Fragment>
			<Pressable style={{
      // To win the specificity war against Emotion we move this into inline styles
      // When Emotion has been stripped from the Design System move this to Compiled.
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      cursor: 'text',
      border: `${"var(--ds-border-width, 1px)"} solid ${fg('platform-dst-tokens-finesse') ? "var(--ds-border-input-search, #0B120E24)" : "var(--ds-border-input, #8C8F97)"}`
    }} onClick={onClick} xcss={cx(styles.root, isFhsEnabled && styles.fullHeightSidebar)} interactionName={interactionName} aria-haspopup={ariaHaspopup}>
				<span className={ax([styles.iconBefore])}>
					<IconBefore color={"var(--ds-icon-subtle, #505258)"} spacing="spacious" label="" />
				</span>
				<div className={ax([styles.buttonText])}>
					<Text color="color.text.subtlest">{label}</Text>
				</div>
				{elemAfter && <span className={ax([styles.elemAfter])}>{elemAfter}</span>}
			</Pressable>
			{/* TODO: replace with media query */}
			<Show below="xs">
				<IconButton label={label} appearance="subtle" icon={SearchIcon} onClick={onClick} interactionName={interactionName} aria-haspopup={ariaHaspopup} />
			</Show>
		</Fragment>;
};